module.exports = __webpack_public_path__ + "static/media/seat-available-symbol.9399124a.svg";